// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import '@/assets/iconfont/iconfont'
import ElementUI from 'element-ui';
import './assets/style.css'

import usertop from '@/components/usertop'
Vue.component('usertop',usertop)

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import axios from 'axios'
const taxios = axios.create({
  withCredentials: true,
})
Vue.prototype.$http = taxios

Vue.use(ElementUI);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js